import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

export default function EleveCoursPage() {
  return (
    <div className="max-w-5xl" data-testid="eleve-cours-page">
      <div className="text-[10.5px] font-black uppercase tracking-[0.22em] text-rose-500 mb-2">Mes cours</div>
      <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
        Mes cours
      </h1>
      <p className="text-sm text-white/60 mt-2 mb-6">Accède à tous les cours du site : thèmes ETM voiture, magazine, tests officiels 2026.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <a href="/formation" target="_blank" rel="noopener noreferrer" className="rounded-xl border border-white/10 bg-white/[0.02] hover:bg-rose-500/10 hover:border-rose-500/30 p-4 transition group flex items-center gap-3" data-testid="cours-formation">
          <div className="w-10 h-10 rounded-lg bg-rose-500/15 text-rose-400 flex items-center justify-center"><BookOpen size={16} /></div>
          <div className="flex-1 min-w-0">
            <div className="text-white font-semibold text-sm">Formation moto</div>
            <div className="text-white/50 text-xs">Thèmes officiels REMC A + ETG 2026</div>
          </div>
          <ArrowRight size={14} className="text-white/30 group-hover:text-rose-400" />
        </a>
        <a href="/voiture" target="_blank" rel="noopener noreferrer" className="rounded-xl border border-white/10 bg-white/[0.02] hover:bg-rose-500/10 hover:border-rose-500/30 p-4 transition group flex items-center gap-3" data-testid="cours-voiture">
          <div className="w-10 h-10 rounded-lg bg-rose-500/15 text-rose-400 flex items-center justify-center"><BookOpen size={16} /></div>
          <div className="flex-1 min-w-0">
            <div className="text-white font-semibold text-sm">Espace voiture</div>
            <div className="text-white/50 text-xs">9 thèmes ETM voiture</div>
          </div>
          <ArrowRight size={14} className="text-white/30 group-hover:text-rose-400" />
        </a>
        <a href="/magazine" target="_blank" rel="noopener noreferrer" className="rounded-xl border border-white/10 bg-white/[0.02] hover:bg-rose-500/10 hover:border-rose-500/30 p-4 transition group flex items-center gap-3" data-testid="cours-magazine">
          <div className="w-10 h-10 rounded-lg bg-rose-500/15 text-rose-400 flex items-center justify-center"><BookOpen size={16} /></div>
          <div className="flex-1 min-w-0">
            <div className="text-white font-semibold text-sm">Magazine</div>
            <div className="text-white/50 text-xs">Enquêtes, dossiers, actu sécurité routière</div>
          </div>
          <ArrowRight size={14} className="text-white/30 group-hover:text-rose-400" />
        </a>
        <a href="/revision" target="_blank" rel="noopener noreferrer" className="rounded-xl border border-white/10 bg-white/[0.02] hover:bg-rose-500/10 hover:border-rose-500/30 p-4 transition group flex items-center gap-3" data-testid="cours-revision">
          <div className="w-10 h-10 rounded-lg bg-rose-500/15 text-rose-400 flex items-center justify-center"><BookOpen size={16} /></div>
          <div className="flex-1 min-w-0">
            <div className="text-white font-semibold text-sm">Révision & tests</div>
            <div className="text-white/50 text-xs">Tests officiels + entraînement libre</div>
          </div>
          <ArrowRight size={14} className="text-white/30 group-hover:text-rose-400" />
        </a>
      </div>
    </div>
  );
}
